import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { RestService } from '../_rest.service';

@Injectable({
  providedIn: 'root'
})
export class ForumInscriptionService extends RestService {
  form: any = {
    step: 1,
    idEvenement: null,
    idUser: null,
    cfa:null,
    user: {
      prenom: null,
      nom: null,
      dateNaissance:null,
      adresse: null,
      adresseAlt: null,
      ville: null,
      pays: null,
      codePostal: null,
      email: null,
      telephone: null,
    },
    salons: {
      petitsalon_rdv: {
        selection: null,
        commentaire: null,
      },
      petitsalon_offres: {
        selection: null,
        commentaire: null,
      },
      selectedItems: [],
    },
    lieux: {
      selectedItems: [],
    },
    offres: {
      selectedItems: [],
    },
  };

  endpointInscription = 'inscriptions/full';

  init() {
    this.endpoint = 'inscriptions';
    this.modelname = 'inscription';
  }

  saveInscription(): Observable<any> {
    const form: any = {};
    form[this.modelname] = this.form;

    return this.http.post<any>(
      environment.apiUrl + '/' + this.endpoint + '?full=1',
      form
    );
  }
  clearFormSessionStorage(){
    console.log('clearFormSessionStorage')
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem('inscriptionForm');
      this.form = {
        step: 1,
        idEvenement: null,
        idUser: null,
        user: {
          prenom: null,
          nom: null,
          dateNaissance:null,
          adresse: null,
          adresseAlt: null,
          ville: null,
          pays: null,
          codePostal: null,
          email: null,
          telephone: null,
        },
        salons: {
          petitsalon_rdv: {
            selection: null,
            commentaire: null,
          },
          petitsalon_offres: {
            selection: null,
            commentaire: null,
          },
          selectedItems: [],
        },
        lieux: {
          selectedItems: [],
        },
        offres: {
          selectedItems: [],
        },
      };
    }
  }
  saveFormSessionStorage() {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('inscriptionForm', JSON.stringify(this.form));
    }
  }
  refreshFormSessionStorage() {
    if (typeof sessionStorage !== 'undefined') {
      if (sessionStorage.getItem('inscriptionForm'))
        this.form = JSON.parse(sessionStorage.getItem('inscriptionForm'));
    }
  }
}
